<template>
    <usage-stats-back-link />
    <div
        ref="loading"
        style="width: auto; height: 300px">
        <library-treemap
            :csvdata="csvData" />
    </div>
</template>

<script setup lang='ts'>
    import LibraryTreemap from '@/shared/components/LibraryTreemap.vue';
    import UsageStatsBackLink from './UsageStatsBackLink.vue';
    import { getLibraryTreeMap } from '@/shared/helpers/api';
    import useBuefy from '@/shared/composables/useBuefy';
    import useShow from '@/shared/composables/useShow';
    import { onMounted, Ref, ref, ShallowRef, useTemplateRef } from 'vue';
    import { http } from '@/shared/httpWrapper';

    const buefy = useBuefy();
    const show = useShow();

    const loading: Ref<boolean> = ref(true);
    const csvData: Ref<string | undefined> = ref(undefined);
    const loadingRef: Readonly<ShallowRef<HTMLElement | null>> = useTemplateRef('loading');

    onMounted(async () => {
        let loadingComponent = undefined;

        if (loadingRef.value !== null) {
            loadingComponent = buefy.loading.open({
                container: loadingRef.value
            });
        }

        try {
            csvData.value = await getLibraryTreeMap(http);
        } catch (err) {
            show.showError('Unable to load libraries');
        } finally {
            loading.value = false;
        }

        if (loadingComponent !== undefined) {
            loadingComponent.close();
        }
    });
</script>

<style scoped>

</style>
